import React, { useEffect, useRef, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { ErrorMessage, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from "yup";
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import errorHandler from '../../utils/errorHandler';
import ApiService from "../../services/categoryManagementApi";
import { modifyDataForReactSelect, modifyReactSelectToString } from '../../utils/CommonFunction';

const { NotificatiopnApi } = ApiService;



const SendNotification = ({ data, setData, notifications }) => {

    const [allUsers, setAllUsers] = useState([])
    const ref = useRef(null);
    const animatedComponents = makeAnimated();
    const [error, setError] = useState();


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: "",
            content: "",
            titleKh: "",
            contentKh: "",
            // userIds: [],
            // dealerIds: [],
            // driverIds: []
        },          
       validationSchema: Yup.object({
        title: Yup.string().required("Title is required").trim(),
        content: Yup.string().required("Content is required").trim(),
        // userIds: Yup.array(),
        // dealerIds: Yup.array(),
        // driverIds: Yup.array()
        }),

        onSubmit: (values, { setSubmitting }) => {
            let allValues = { ...values };
            // allValues.userIds = modifyReactSelectToString(allValues.userIds);
            // allValues.dealerIds = modifyReactSelectToString(allValues.dealerIds);
            // allValues.driverIds = modifyReactSelectToString(allValues.driverIds);
            handleSubmit(allValues, setSubmitting);
          }
          
    });
    const { values, setFieldValue, isSubmitting } = formik;

    const handleSubmit = async (values, setSubmitting) => {
        try {
            // if(values?.userIds.length == 0 && values.dealerIds.length == 0 && values.driverIds.length == 0){
            //     setError("Please select at least one User, Dealer, or Driver");
            //     return;
            // }
            const payload= {
                ...values,
                notifications
            }
            if (data?.status == 1) {
                let res = await NotificatiopnApi.sendNotificationToUsers(payload)
                toast.success(res?.data?.message)
                setData({ open: false, id: "" })
                formik.resetForm()
            } else {
                toast.error("Notificaiton status is inactive")
            }
        } catch (error) {
            errorHandler(error)
        } finally {
            setSubmitting(false)
        }
    }

    const handleClose = () => {
        if (!isSubmitting) {
            setData({ open: false, id: "" })
            formik.resetForm()
        }
    }


    useEffect(() => {
        const getData = async () => {
          try {
            let res = await NotificatiopnApi.getOneNotificationTemplate(data?.id);
            formik.setFieldValue("title", res?.data?.data?.title);
            formik.setFieldValue("content", res?.data?.data?.content);
            formik.setFieldValue("titleKh", res?.data?.data?.titleKh);
            formik.setFieldValue("contentKh", res?.data?.data?.contentKh);
      
            let users = await NotificatiopnApi.getUsers();
            
            setAllUsers({
              user: modifyDataForReactSelect(users?.data?.data?.user || [], "name", "_id"),
              dealer: modifyDataForReactSelect(users?.data?.data?.dealer || [], "businessName", "_id"),
              driver: modifyDataForReactSelect(users?.data?.data?.driver || [], "name", "_id"),
            });
          } catch (error) {
            errorHandler(error);
          }
        };
      
        if (data?.id) getData();
      }, [data]);
      



    return (
        <>

            <Dialog
                open={data.open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                ref={ref}
            
            >
                <DialogContent style={{ minWidth: '600px' }}>
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" onSubmit={formik.handleSubmit}>

                            <Typography variant='h4' sx>Send Notification</Typography>
                            <hr />

                            {error && (
                                <Typography sx={{ color: 'red', fontWeight: "bold", marginBottom: "10px", background: "#e2d6179c", padding: "16px" }}>
                                {error}
                                </Typography>
                            )}
                            <Typography sx={{ fontWeight: "bold", marginTop: "24px" }}>Title</Typography>
                            <Typography id="alert-dialog-description">
                                {formik.values.title}
                            </Typography>

                             <Typography sx={{ fontWeight: "bold", marginTop: "24px" }}>Title (Khmer)</Typography>
                            <Typography id="alert-dialog-description">
                                {formik.values.titleKh}
                            </Typography>

                            <Typography sx={{ fontWeight: "bold", marginTop: "18px" }}>Content</Typography>
                            <Typography id="alert-dialog-description">
                                {formik.values.content}
                            </Typography>

                               <Typography sx={{ fontWeight: "bold", marginTop: "18px" }}>Content (khmer)</Typography>
                            <Typography id="alert-dialog-description">
                                {formik.values.contentKh}
                            </Typography>


                            {/* <Typography sx={{ fontWeight: "bold", marginTop: "20px" }}>Select Users</Typography>
                            <div className="noti-modal-select">
                            <Select
                                onChange={(e) => setFieldValue("userIds", e)}
                                options={allUsers.user}
                                menuPortalTarget={ref.current}
                                isMulti
                                value={values.userIds}
                                components={animatedComponents}
                                placeholder="Select users"
                            />
                            <ErrorMessage className="errorMessage" name='userIds' component={"div"} />
                            </div>

                            <Typography sx={{ fontWeight: "bold", marginTop: "20px" }}>Select Dealers</Typography>
                            <div className="noti-modal-select">
                            <Select
                                onChange={(e) => setFieldValue("dealerIds", e)}
                                options={allUsers.dealer}
                                menuPortalTarget={ref.current}
                                isMulti
                                value={values.dealerIds}
                                components={animatedComponents}
                                placeholder="Select dealers"
                            />
                            <ErrorMessage className="errorMessage" name='dealerIds' component={"div"} />
                            </div>

                            <Typography sx={{ fontWeight: "bold", marginTop: "20px" }}>Select Drivers</Typography>
                            <div className="noti-modal-select">
                            <Select
                                onChange={(e) => setFieldValue("driverIds", e)}
                                options={allUsers.driver}
                                menuPortalTarget={ref.current}
                                isMulti
                                value={values.driverIds}
                                components={animatedComponents}
                                placeholder="Select drivers"
                            />
                            <ErrorMessage className="errorMessage" name='driverIds' component={"div"} />
                            </div> */}




                            <DialogActions style={{ paddingRight: 0, paddingTop: "15px" }}>
                                {isSubmitting ?
                                    <LoadingButton loading variant="outlined" > Loading </LoadingButton>
                                    :
                                    <Button variant="contained" type="submit" >
                                        Send
                                    </Button>
                                }
                                <Button variant="outlined" onClick={handleClose} disabled={isSubmitting}>
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Form>
                    </FormikProvider>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default SendNotification